import React from 'react'
import MaterialSymbol from '../material-symbol'

const PersonOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="person_outline" {...props} />
))

PersonOutline.displayName = 'PersonOutline'

export default PersonOutline
